<ng-container *ngIf="items">
  <p-fieldset legend="Active">
    <app-course-price-rule-table [rows]="actives"
                                 (dataChanged)="emitDataChanged($event)">
    </app-course-price-rule-table>
  </p-fieldset>

  <br>

  <p-fieldset legend="Inactive ({{inActives?.length}} rules)" [toggleable]="true" [collapsed]="collapsed">
    <app-course-price-rule-table [rows]="inActives"
                                 (dataChanged)="emitDataChanged($event)">
    </app-course-price-rule-table>
  </p-fieldset>
</ng-container>




